export class FileInfo {
    constructor(
        public Name: string,
        public fileByteArray: string) {        
    }
}
